import React, { useState } from 'react';
import '../Navbar/Navbar.css';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const NavbarCjjbf = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };
  

  // Close the navbar when a link is clicked
  const handleLinkClick = (url) => {
    setIsOpen(false);

    if (url === '/contact') {
      navigate('/contact');

      setTimeout(() => {
        const section = document.getElementById('contact');

        if (section) {
          section.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);

      return;
    }

    if (location.pathname === url) {
      window.scrollTo(0, 0);
    } else {
      navigate(url);
    }
  };
  

  return (
    <header>
      <Link to='/' className="logo" onClick={() => handleLinkClick('/')}>
        <img src="/cjjbf-logo-new-2026.png" alt="CJJBF Logo" className="logo-img" />
        CJJ BELGIAN FEDERATION
      </Link>
      <nav>
        <ul className={`nav__links ${isOpen ? 'active' : ''}`}>
          <li><Link to="/" onClick={() => handleLinkClick('/')}>HOME</Link></li>
          <li><Link to="/whatiscombatjujutsu" onClick={() => handleLinkClick('/combat')}>COMBAT-JUTSU</Link></li>
          <li><Link to="/ourteam" onClick={() => handleLinkClick('/team')}>OUR TEAM</Link></li>
          <li><Link to="/contact" onClick={() => handleLinkClick('/contact')}>CONTACT</Link></li>
        </ul>
      </nav>
      <button className={`toggle-button ${isOpen ? 'open' : ''}`} onClick={handleToggle}>
        <span className="bar"></span>
        <span className="bar"></span>
        <span className="bar"></span>
      </button>
    </header>
  );
};

export default NavbarCjjbf;